export const envActions: Readonly<any> = {
    Build: 'Build',
    BuildByTask: 'BuildByTask',
    Upgrade: 'Upgrade',
    ApplyLabel: 'ApplyLabel',
    SetType: 'SetType',
    Validate: 'Validate',
    PreValidate: 'PreValidate', 
    ViewLabels: 'ViewLabels',
    Rollback: 'Rollback',
    Details: 'Details',
    SetVersion: 'SetVersion',
    ExitIntegration: 'ExitIntegration',
    Advanced: 'Advanced',
    RunPackage: 'RunPackage',
    GetSpecific: 'GetSpecific',
    GetLatest: 'GetLatest',
    BackupEnvironment: 'BackupEnvironment',
    RestoreEnvironment: 'RestoreEnvironment',
    UpdateSourceControl: 'UpdateSourceControl'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/envActions.ts